<script>
    import user from "./stores/user";
    import success from './stores/success';
    import error from "./stores/error";
    import {router} from './router/Router.svelte';
    import {updateClientAccount} from "./requests";
    import {generateApiKey} from './lib/lib';

    import InputOriginator from './InputOriginator.svelte';

    let account = {
        id: $user.id,
        name: $user.name,
        lastname: $user.lastname,
        phone: $user.phone,
        mobile: $user.mobile,
        email: $user.email,
        api_key: $user.api_key,
        originator: $user.originator,
        username: $user.username,
        new_password: "",
    };
    let changePassword = false;
    let originatorValid = true;
    let isValid = true;

    const close = () => {
        router._go("/app");
    }

    const createApiKey = () => {
        account.api_key = generateApiKey();
    }

    const updateAccount = async () => {
        if (isValid) {
            if (!changePassword) account.new_password = "";

            let [err, res] = await updateClientAccount(account);

            if (err) {
                return;
            }

            success.show("Ο λογαριασμός σας ενημερώθηκε.");
            user.updateAccount(res);

            account.new_password = "";
            changePassword = false;
        }
    }

    const copyToClipboard = () => {
        let textArea = document.createElement("textarea");
        textArea.value = account.api_key;
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            let successful = document.execCommand('copy');
            if (successful) {
                success.show("Το κλειδί αντιγράφτηκε στο πρόχειρο.");
            } else {
                error.show("Η εφαρμογή δεν μπόρεσε να αντιγράψει το κλειδί στο πρόχειρο!");
            }
        } catch (err) {
            error.show("Η εφαρμογή δεν μπόρεσε να αντιγράψει το κλειδί στο πρόχειρο!");
        }

        document.body.removeChild(textArea);
    }

    $: {
        isValid = originatorValid;
    }
</script>

<div class="page-header">
    <div class="page-title">Ο Λογαριασμός μου</div>
    <div class="controls">
        <div title="Κλείσιμο" on:click|preventDefault="{ close }">
            <span class="icon"><i class="fa fa-times"></i></span>
        </div>
    </div>
</div>
<div class="page">
    <div class="page-main">
        <div class="row">
            <div class="col-lg-4 col-md-3">

            </div>
            <div class="col-lg-4 col-md-6">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 style="margin:0;">Στοιχεία λογαριασμού</h4>
                    </div>
                    <div class="panel-body">
                        <form on:submit|preventDefault="{ updateAccount }">
                            <div class="form-group">
                                <label>ΟΝΟΜΑ</label>
                                <input type="text" class="form-control" bind:value="{ account.name }" required>
                            </div>
                            <div class="form-group">
                                <label>ΕΠΙΘΕΤΟ</label>
                                <input type="text" class="form-control" bind:value="{ account.lastname }">
                            </div>
                            <div class="form-group">
                                <label>ΤΗΛΕΦΩΝΟ</label>
                                <input type="text" class="form-control" bind:value="{ account.phone }">
                            </div>
                            <div class="form-group">
                                <label>ΚΙΝΗΤΟ</label>
                                <input type="text" class="form-control" bind:value="{ account.mobile }" required>
                            </div>
                            <div class="form-group">
                                <label>EMAIL</label>
                                <input type="email" class="form-control" bind:value="{ account.email }" required>
                            </div>
                            <hr>
                            <div class="form-group">
                                <label>ΑΠΟΣΤΟΛΕΑΣ</label>
                                <InputOriginator bind:originator="{ account.originator }"
                                                 bind:originatorIsValid="{ originatorValid }"/>
                            </div>
                            <div class="form-group">
                                <label>ΟΝΟΜΑ ΧΡΗΣΤΗ</label>
                                <input type="text" class="form-control" bind:value="{ account.username }" required>
                            </div>
                            {#if !changePassword}
                                <span class="btn btn-info btn-block mrg-b-md"
                                      on:click="{ () => changePassword = true }">Αλλαγή κωδικού</span>
                            {/if}
                            {#if changePassword}
                                <hr>
                                <div class="form-group">
                                    <label>ΝΕΟΣ ΚΩΔΙΚΟΣ</label>
                                    <input type="text" class="form-control" bind:value="{ account.new_password }"
                                           required>
                                </div>
                                <span class="btn btn-info btn-block mrg-b-md"
                                      on:click="{ () => changePassword = false }">Ακύρωση</span>
                            {/if}
                            <hr>
                            <div class="form-group">
                                <label>Κλειδί API</label>
                                <input type="text" class="form-control" bind:value="{ account.api_key }" readonly>
                            </div>
                            {#if !account.api_key}
                                <button class="btn btn-info btn-block" on:click="{ createApiKey }">
                                    Δημιουργία κλειδιού API
                                </button>
                            {:else}
                                <button class="btn btn-info btn-block"
                                        on:click|preventDefault|stopPropagation="{ copyToClipboard }">
                                    Αντιγραφή κλειδιού στο πρόχειρο
                                </button>
                            {/if}

                            <hr>
                            <div class="text-right">
                                <input type="submit" class="btn btn-primary btn-block" value="Ενημέρωση">
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
            </div>
        </div>
    </div>
</div>